import React, { Fragment } from "react";

import {
  APP_VERSION,
  STL_URL,
  STL_LINKEDIN_URL,
  STL_FACEBOOK_URL,
  STL_TWITTER_URL,
} from "../../../constants";
import STLLogo from "../../Logo/STL/STLLogo";

const systemCopyright = (props) => (
  <footer
    className={`page-copyright ${props.lockScreen && "page-copyright-inverse"}`}
  >
    {!(props.lockScreen || props.forgotPassword || props.error404) && (
      <STLLogo />
    )}

    <p>{APP_VERSION}</p>
    <p>
      Copyright &copy; {new Date().getFullYear()}{" "}
      <a href={STL_URL} target="_blank" rel="noopener noreferrer">
        Software Technologies Limited
      </a>
    </p>

    <div className="social">
      {(props.lockScreen || props.forgotPassword || props.error404) && (
        <Fragment>
          <a href={STL_LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
            <i className="icon bd-linkedin" aria-hidden="true"></i>
          </a>
          &nbsp;
          <a href={STL_FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
            <i className="icon bd-facebook" aria-hidden="true"></i>
          </a>
          &nbsp;
          <a href={STL_TWITTER_URL} target="_blank" rel="noopener noreferrer">
            <i className="icon bd-twitter" aria-hidden="true"></i>
          </a>
        </Fragment>
      )}

      {!(props.lockScreen || props.forgotPassword || props.error404) && (
        <Fragment>
          <a
            className="btn btn-xs btn-icon btn-labeled social-linkedin waves-effect waves-classic mx-5"
            href={STL_LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="btn-label">
              <i className="icon bd-linkedin" aria-hidden="true"></i>
            </span>
            &nbsp;Linkedin
          </a>
          <a
            className="btn btn-xs btn-icon btn-labeled social-facebook waves-effect waves-classic mx-5"
            href={STL_FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="btn-label">
              <i className="icon bd-facebook" aria-hidden="true"></i>
              &nbsp;Facebook
            </span>
          </a>
          <a
            className="btn btn-xs btn-icon btn-labeled social-twitter waves-effect waves-classic mx-5"
            href={STL_TWITTER_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="btn-label">
              <i className="icon bd-twitter" aria-hidden="true"></i>
              &nbsp;Twitter
            </span>
          </a>
        </Fragment>
      )}
    </div>
  </footer>
);

export default systemCopyright;
